import { LEGAL_LINKS, legalDocumentPath } from "@/config/legal/links";
import { cn } from "@/lib/utils";

/**
 * NP-582 — Terms of Use, Privacy Policy and Disclaimer, in one place.
 *
 * Rendered by `PublicPageShell` (every pre-login page and the legal pages themselves)
 * and by `AppShell` (every authenticated page), so a new page inherits the links
 * instead of adding them — the technical note's own rule.
 *
 * AC-9: these now point at PATH's own pages rather than afncorp.com. The corporate
 * pages work, but they carry the marketing site's header and "Apply Now" nav, so a
 * borrower mid-application landed somewhere that looked nothing like their
 * application. Still `target="_blank"` — AC-2 keeps the current page and any unsaved
 * form data untouched — which also means these stay plain anchors rather than router
 * `Link`s, since a new tab is a fresh document load either way.
 */
export const LegalFooterLinks = ({ className }: { className?: string }) => (
  <div
    // AC-7: wraps rather than overflowing, so the three stack on a narrow viewport.
    // min-h-[44px] is the login footer's touch target, kept so the links stay tappable.
    className={cn(
      "flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground",
      className,
    )}
    data-testid="legal-footer-links"
  >
    {LEGAL_LINKS.map(({ slug, label }) => (
      <a
        key={slug}
        href={legalDocumentPath(slug)}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline min-h-[44px] flex items-center"
        data-testid={`legal-${slug}-link`}
      >
        {label}
      </a>
    ))}
  </div>
);
